/**
 * Asegura que el input de porcentaje de beneficio contenga un valor entero entre 0 y 99
 *
 * @param {HTMLInputElement} input
 */
window.validarPorcentajeBeneficio = function (input) {
    const value  = input.value.trim();
    const parsed = parseInt(value, 10);

    if (isNaN(parsed) || parsed < 0 || parsed > 99) {
        input.value = '99';
    } else {
        input.value = parsed.toString();
    }
}
